import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'transactionRuleOperatorText',
    standalone: true
})
export class TransactionRuleOperatorTextPipe implements PipeTransform {

    transform(operator: string): string {
        switch (operator) {
            case 'CONTAINS':
                return 'Enthält';
            case 'EQUAL':
                return 'Gleich';
            case 'LESS_THAN':
                return 'Kleiner als';
            case 'GREATER_THAN':
                return 'Größer als';
            default:
                return 'Unbekannt';
        }
    }

}
